export const checkBoxCreditAssignment = 'checkBoxCreditAssignment';
